import { getCompanyCodeFromToken } from "./authService";
import { API_URL } from "./apiConfig";

const companyCode = getCompanyCodeFromToken();

export const fetchNotifications = async (roles, userName) => {
  try {
    const response = await fetch(`${API_URL}Home/GetNotification/${roles}/${companyCode}/${userName}`);
    if (!response.ok) throw new Error("Failed to fetch notifications");
    return await response.json();
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return [];
  }
};
